import { render } from "./NotFound.vue?vue&type=template&id=9ae56c98"
const script = {}
script.render = render

export default script